module.exports = __webpack_public_path__ + "static/media/spin-refresh-icon-static.22eeaf10.png";